import {createReducer} from '../utility'




export const awardTypes = createReducer({},{
    "FETCH_AWARD_TYPES_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                awardType: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})